export default [
  {
    path: 'details-notice-system/:id/:type?',
    name: 'details-notice-system',
    component: () => import('@/views/home/components/home-page/details-notice-system.vue'),
    meta: { title: '文章详情' },
    props: true
  }
]
